import { ReactElement } from 'react'
import { Box, Divider, InputAdornment, Stack, Typography } from '@mui/material'
import { CoordinatePointInput, TextField } from '@ui/forms'

interface BuildingDimensionsInputProps {
  label: string
  fieldName: string
  labelColor?: string
}

const BuildingDimensionsInput = ({
  label,
  fieldName,
  labelColor,
}: BuildingDimensionsInputProps): ReactElement => (
  <Stack direction="column" spacing={1}>
    <Divider textAlign="center">
      <Typography fontSize={'inherit'} sx={{ color: labelColor }}>
        {label}
      </Typography>
    </Divider>
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
      <Typography fontSize={'inherit'}>Maße</Typography>
      <Box sx={{ width: '130px' }}></Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={0.5}>
        <TextField
          inputLabel="Breite - w. parallel"
          name={`${fieldName}.width`}
          type="number"
          InputProps={{
            endAdornment: <InputAdornment position="end">m</InputAdornment>,
          }}
        />
        <TextField
          inputLabel="Länge"
          name={`${fieldName}.depth`}
          type="number"
          InputProps={{
            endAdornment: <InputAdornment position="end">m</InputAdornment>,
          }}
        />
        <TextField
          inputLabel="Höhe"
          name={`${fieldName}.height`}
          type="number"
          InputProps={{
            endAdornment: <InputAdornment position="end">m</InputAdornment>,
          }}
        />
      </Stack>
    </Stack>
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
      <Typography fontSize={'inherit'}>Position</Typography>
      <CoordinatePointInput
        name={`${fieldName}.start`}
        label="Start"
        coordinatePickerPosition="front"
      />
    </Stack>
  </Stack>
)

export default BuildingDimensionsInput
